import { render } from "./TheTinhTp.vue?vue&type=template&id=12c2b492"
import script from "./TheTinhTp.vue?vue&type=script&lang=js"
export * from "./TheTinhTp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__